import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    user: {},
    token: "",
    bank: {}
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {

        // params: {user, token}
        login: (state, action) => {
            state.user = action.payload.user;
            state.token = action.payload.token;
        },
        logout: (state, action) => {
            state.user = {};
            state.token = ""
        },

        saveBank: (state, action) => {
            state.bank = action.payload;
        }
    },
})

// Action creators are generated for each case reducer function
export const { login, logout, saveBank } = userSlice.actions;

export default userSlice.reducer;